
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { StudentStatusResponse } from "../../models/dtos";

export const studentStatusesApi = createApi({
  reducerPath: 'studentStatusesApi',
  baseQuery: baseAuthQuery('StudentStatuses'),
  tagTypes: ['StudentStatus'],
  endpoints: (builder) => ({
    getStudentStatuses: builder.query<ApiResponse<StudentStatusResponse[]>, void>({
      query: () => "",
      providesTags: ['StudentStatus'],
    }),
    getStudentStatusById: builder.query<ApiResponse<StudentStatusResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['StudentStatus'],
    }),
    updateStudentStatus: builder.mutation<ApiResponse<StudentStatusResponse>, Partial<StudentStatusResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['StudentStatus'],
    }),
    deleteStudentStatus: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['StudentStatus'],
    }),
  }),
});
